import { useMemo } from 'react'
import { GetDemoTourCategoriesDocument } from 'generated/resources/graphql'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

export interface DemoTourTask {
  taskKey: string
  title: string
  description: string | null
}

export function useDemoTourTasks({ skip = false }: { skip?: boolean } = {}) {
  const { data, loading, error } = useQuery(GetDemoTourCategoriesDocument, {
    variables: { locale: i18n.locale },
    skip,
  })

  const tasks = useMemo(() => {
    if (!data) return []

    return data.getStarted.demoTourCategoriesConnection.nodes.flatMap((category) =>
      category.tasks.map((task) => ({
        taskKey: task.taskKey,
        title: task.title,
        description: task.description ?? null,
      }))
    )
  }, [data])

  return { tasks, loading, error }
}
